import { getRootVar } from '@immosky/shared';
import { colorOrange } from '@immosky/styles';
import {
  GeometryType,
  MapShapeRenderer,
  Region,
  RegionID,
} from '@immosky/types';

export class MapMultiPolygonRenderer implements MapShapeRenderer {
  private activePolygonGroups = new Map<RegionID, google.maps.Polygon[][]>();
  private regions: Region[] = [];

  constructor(private map: google.maps.Map) {}

  update(regions: Region[]): void {
    this.regions = regions;
    this.createAllPolygons();
  }

  clear() {
    for (const [key, groups] of this.activePolygonGroups) {
      for (const group of groups) {
        for (const polygon of group) {
          polygon.setMap(null);
        }
      }
    }
    this.activePolygonGroups.clear();
  }

  getBounds(): google.maps.LatLng[] {
    const bounds: google.maps.LatLng[] = [];

    for (const [key, groups] of this.activePolygonGroups) {
      for (const group of groups) {
        for (const polygon of group) {
          const coordinates = polygon.getPath().getArray();
          for (const coordinate of coordinates) {
            bounds.push(coordinate);
          }
        }
      }
    }

    return bounds;
  }

  private createAllPolygons() {
    for (const region of this.regions) {
      this.createPolygonsForRegion(region);
    }
  }

  private createPolygonsForRegion(region: Region) {
    if (region.geometry.type === GeometryType.MULTI_POLYGON) {
      if (this.activePolygonGroups.has(region.id)) {
        return;
      }

      const groups = region.geometry.coordinates;
      const polygonGroups: google.maps.Polygon[][] = [];

      for (const group of groups) {
        const polygons: google.maps.Polygon[] = [];

        for (const shape of group) {
          const polygon = new google.maps.Polygon({
            paths: shape,
            strokeColor: getRootVar('--primary-color', colorOrange),
            strokeWeight: 2,
            strokeOpacity: 0.4,
            fillColor: getRootVar('--primary-color', colorOrange),
            fillOpacity: 0.2,
            map: this.map,
            clickable: false,
          });

          polygons.push(polygon);
        }

        polygonGroups.push(polygons);
      }

      this.activePolygonGroups.set(region.id, polygonGroups);
    }
  }
}
